import { render, staticRenderFns } from "./CustomLabel.vue?vue&type=template&id=4e8e7c77&scoped=true&"
import script from "./CustomLabel.vue?vue&type=script&lang=js&"
export * from "./CustomLabel.vue?vue&type=script&lang=js&"
import style0 from "./CustomLabel.vue?vue&type=style&index=0&id=4e8e7c77&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e8e7c77",
  null
  
)

export default component.exports